// Constants
import { VIMEO_REGEX, YOUTUBE_REGEX } from '@/common/constants';

const getVideoThumbnail = (path, video) => {
  let thumbnail = '';

  if (path.match(VIMEO_REGEX) && video && video.length > 0) {
    thumbnail = video[0].thumbnail_large;
  } else if (path.match(YOUTUBE_REGEX)) {
    const id = path.match(YOUTUBE_REGEX)[2];
    const format = 'hqdefault';

    thumbnail = `https://img.youtube.com/vi/${id}/${format}.jpg`;
  }

  return thumbnail;
};

export default getVideoThumbnail;
